import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=f9d4195c&scoped=true";
import script from "./UpdatePassword.vue?vue&type=script&lang=js";
export * from "./UpdatePassword.vue?vue&type=script&lang=js";
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=f9d4195c&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "f9d4195c", null);
export default component.exports;